function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVirtualBackground = function SvgVirtualBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.88.365H9.57a2.664 2.664 0 0 0-2.664 2.663v21.31a2.664 2.664 0 0 0 2.664 2.664H30.879a2.664 2.664 0 0 0 2.664-2.664V3.028A2.664 2.664 0 0 0 30.88.365zM16.355 17.36l2.86 4.144 4.24-9.79a1.332 1.332 0 0 1 2.41-.074l5.013 9.875V3.028H9.57v20.99l4.595-6.658a1.332 1.332 0 0 1 2.192 0zm-.127-3.677a3.996 3.996 0 1 1 0-7.99 3.996 3.996 0 0 1 0 7.99zm1.332-3.995a1.332 1.332 0 1 1-2.664 0 1.332 1.332 0 0 1 2.664 0zm7.213 5.685 4.551 8.965h-8.434zm-9.514 5.089 2.675 3.876h-5.35z",
    style: {
      strokeWidth: 1.33186
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: 8,
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      wordSpacing: 0
    },
    x: -0.481,
    y: 39.535
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -0.481,
    y: 39.535,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: 8,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "SCENERY")));
};
export default SvgVirtualBackground;